import React from 'react'

// Components
import BannerDefault from 'components/flex/Banner/BannerDefault'
import BannerAccordion from 'components/flex/Banner/BannerAccordion'
import BannerHome from 'components/flex/Banner/BannerHome'

interface BannerShellProps {
  fields: any
  location?: any
}

interface BannersProps {
  [key: string]: any
}

const BannerShell: React.FC<BannerShellProps> = ({ fields, location = {} }) => {
  const banners: BannersProps = {
    default: BannerDefault,
    home: BannerHome,
    accordion: BannerAccordion,
  }

  if (!fields.styletype || !banners[fields.styletype]) {
    return null
  }

  const Component = banners[fields.styletype]

  return (
    <Component
      key={`${location ? location.pathname : 'flex'}`}
      fields={fields}
      location={location}
    />
  )
}

export default BannerShell
